import * as protocol from './protocol'
import * as inviteFriends from './inviteFriends'
import * as inviteRegiste from './inviteRegiste'
import * as inviteHelp from './inviteHelp'
import * as stamp from './stamp'
import * as noticeDetail from './noticeDetail'
import * as help from './help'
import * as shop from './shop'
export default { ...protocol, ...inviteFriends, ...inviteRegiste, ...stamp, ...noticeDetail, ...inviteHelp, ...help, ...shop }
